import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        console.log('canActivate');

        const redirectUrl = state.url === '/login' ? '/dashboard/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        console.log('canActivateChild');

        const redirectUrl = state.url === '/login' ? '/dashboard/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can load
     *
     * @param route
     * @param segments
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean
    {
        console.log('canLoad');

        return this._check('/');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param redirectURL
     * @private
     */
    /* private _check(redirectURL: string): Observable<boolean>
    {
        console.log("check guard call");
        // Check the authentication status
        return this._authService.check().pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if ( !authenticated ) {
                    // Redirect to the sign-in page
                    console.log("not auth");
                    //this._router.navigate(['/dashboard/'], {queryParams: {redirectURL}});
                    this._router.navigate(['/login/']);

                    // Prevent the access
                    return of(false);
                }

                // Allow the access
                return of(true);
            })
        );
    } */

    /**
     * Check the authenticated status
     *
     * @param redirectURL
     * @private
     */
    private _check(redirectURL: string): Observable<boolean>
    {
        // console.log("check guard call");
        // Check the authentication status
        let flag_corporative = this._authService.check_is_corporative();
        let flag_installer = this._authService.check_is_installer();

        const permissions = this._authService.allowed_pages;        

        // Verificar permisos de página
        const hasPageAccess = permissions.some(page => `/${page}` === redirectURL || redirectURL == '/dashboard-comercial');

        // Verificar si el usuario tiene todos los permisos
        const hasAllPermissions = permissions.includes('all');

        if(flag_corporative || flag_installer){
            if (flag_corporative) {
                if (hasPageAccess || hasAllPermissions) {
                    return of(true); // Permitir acceso
                }
                else {
                    this._router.navigate(['/dashboard-comercial']);
                    return of(false);
                }
            }
            return of(true);
        }
        else{
            this._router.navigate(['/login/']);
            return of(false);
        }
    }
}
